// ====================================================================================
// --- 1. 粘性加入购物车栏 (移动端) ---
// 功能：当用户在移动设备上向下滚动，经过原始的“加入购物车”按钮后，在屏幕底部显示一个粘性的操作栏。
// ====================================================================================
document.addEventListener('DOMContentLoaded', function() {
  if (window.matchMedia("(max-width: 767px)").matches) {
    const originalContainer = document.querySelector('.product-page--submit-action');
    const originalAddToCartBtn = document.getElementById('purchase');
    const originalBuyItNowBtn = document.getElementById('custom-paypal-button');

    if (!originalContainer || !originalAddToCartBtn || !originalBuyItNowBtn) {
      return;
    }

    const stickyBar = document.createElement('div');
    stickyBar.className = 'sticky-add-to-cart-bar';

    const stickyBuyItNowBtn = document.createElement('div');
    stickyBuyItNowBtn.className = 'sticky-btn sticky-bin-btn';
    stickyBuyItNowBtn.innerHTML = originalBuyItNowBtn.innerHTML;
    stickyBuyItNowBtn.setAttribute('role', 'button');
    stickyBuyItNowBtn.setAttribute('tabindex', '0');

    const stickyAddToCartBtn = document.createElement('button');
    stickyAddToCartBtn.className = 'sticky-btn sticky-atc-btn';
    
    stickyBar.appendChild(stickyBuyItNowBtn);
    stickyBar.appendChild(stickyAddToCartBtn);
    document.body.appendChild(stickyBar);

    function alignStickyBar() {
      const productForm = originalContainer.closest('form[action*="/cart/add"]');
      const referenceElement = productForm || originalContainer;
      const rect = referenceElement.getBoundingClientRect();
      stickyBar.style.left = `${rect.left}px`;
      stickyBar.style.width = `${rect.width}px`;
    }

    alignStickyBar();
    window.addEventListener('resize', alignStickyBar);

    function syncStickyButtonState() {
      const isDisabled = originalAddToCartBtn.disabled;
      
      stickyAddToCartBtn.innerHTML = originalAddToCartBtn.innerHTML;
      stickyAddToCartBtn.disabled = isDisabled; 
      
      if (isDisabled) {
        stickyBuyItNowBtn.classList.add('disabled');
        stickyBuyItNowBtn.setAttribute('aria-disabled', 'true');
      } else {
        stickyBuyItNowBtn.classList.remove('disabled');
        stickyBuyItNowBtn.setAttribute('aria-disabled', 'false');
      }
    }

    stickyAddToCartBtn.addEventListener('click', () => {
      if (!stickyAddToCartBtn.disabled) { originalAddToCartBtn.click(); }
    });

    stickyBuyItNowBtn.addEventListener('click', () => {
      if (!stickyBuyItNowBtn.classList.contains('disabled')) { 
        originalBuyItNowBtn.click(); 
      }
    });

    const scrollObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const isAboveViewport = entry.boundingClientRect.bottom < 0;
        if (entry.isIntersecting) {
          stickyBar.classList.remove('visible');
        } else {
          if (isAboveViewport) {
            syncStickyButtonState();
            stickyBar.classList.add('visible');
          } else {
            stickyBar.classList.remove('visible');
          }
        }
      });
    }, { root: null, threshold: 0 });
    scrollObserver.observe(originalContainer);
    
    const variantObserver = new MutationObserver(syncStickyButtonState);
    variantObserver.observe(originalAddToCartBtn, { attributes: true, childList: true, subtree: true });

    function handleOverlayState() {
      const searchWrapper = document.getElementById('top-search-wrapper');
      const isSearchActive = searchWrapper && searchWrapper.classList.contains('expanded');

      if (isSearchActive) {
        stickyBar.classList.add('sticky-bar--hidden-by-modal');
      } else {
        stickyBar.classList.remove('sticky-bar--hidden-by-modal');
      }
    }

    const searchWrapperTarget = document.getElementById('top-search-wrapper');
    if (searchWrapperTarget) {
      const searchObserver = new MutationObserver(handleOverlayState);
      searchObserver.observe(searchWrapperTarget, {
        attributes: true,
        attributeFilter: ['class']
      });
    }
    handleOverlayState();
    const menuSelector = '#theme-menu';
    const stickyBarSelector = '.sticky-add-to-cart-bar'; 

    setInterval(function() {
      const menu = document.querySelector(menuSelector);
      const stickyBarElement = document.querySelector(stickyBarSelector);

      if (!menu || !stickyBarElement) {
        return;
      }

      const isMenuOpen = !menu.classList.contains('slideout-panel-hidden');

      if (isMenuOpen) {
        if (stickyBarElement.style.display !== 'none') {
          stickyBarElement.style.setProperty('display', 'none', 'important');
        }
      } else {
        if (stickyBarElement.style.display === 'none') {
          stickyBarElement.style.removeProperty('display');
        }
      }
    }, 100); 

  } 
});


// ====================================================================================
// --- 2. 自定义产品图片缩略图 (移动端) ---
// 功能：创建自定义的图片缩略图，并与主产品图的 Swiper 轮播进行同步。
// ====================================================================================
document.addEventListener('DOMContentLoaded', () => {
    const customThumbnailsOuterContainer = document.querySelector('.mobile-thumbnail-pagination');
    const customThumbnailsInnerContainer = document.querySelector('.mobile-thumbnail-pagination__inner');
    const originalSwiperPaginationContainerSelector = '.swiper-pagination.swiper-pagination-clickable.swiper-pagination-bullets';

    if (customThumbnailsOuterContainer) {
        setTimeout(() => {
            customThumbnailsOuterContainer.classList.add('visible');
        }, 100);
    }

    const customThumbnails = customThumbnailsInnerContainer ? customThumbnailsInnerContainer.querySelectorAll('.mobile-thumbnail-item') : [];

    if (customThumbnails.length > 0) {
        function handleCustomThumbnailClick(event) {
            event.preventDefault();
            const clickedCustomThumbnail = event.currentTarget;
            const targetIndex = parseInt(clickedCustomThumbnail.dataset.index, 10);

            if (isNaN(targetIndex)) {
                return;
            }

            const originalPaginationContainer = document.querySelector(originalSwiperPaginationContainerSelector);
            if (!originalPaginationContainer) {
                return;
            }

            const originalBullets = originalPaginationContainer.querySelectorAll('.swiper-pagination-bullet');

            if (originalBullets.length > targetIndex && originalBullets[targetIndex]) {
                originalBullets[targetIndex].click();

                customThumbnails.forEach((thumb, idx) => {
                    thumb.classList.toggle('active', idx === targetIndex);
                    thumb.setAttribute('aria-current', idx === targetIndex ? 'true' : 'false');
                });
            }
        }

        customThumbnails.forEach(thumb => {
            thumb.addEventListener('click', handleCustomThumbnailClick);
        });
    }

    function setupObserver(targetNode) {
        const observerCallback = (mutationsList, observer) => {
            let activeClassChangedOnBullet = false;
            for (const mutation of mutationsList) {
                 if (mutation.type === 'attributes' &&
                     mutation.attributeName === 'class' &&
                     mutation.target.classList.contains('swiper-pagination-bullet')) {
                      activeClassChangedOnBullet = true;
                      break;
                 }
            }

            if (activeClassChangedOnBullet && customThumbnailsInnerContainer && customThumbnails.length > 0) {
                const originalBullets = Array.from(targetNode.querySelectorAll('.swiper-pagination-bullet'));
                let activeOriginalBulletIndex = originalBullets.findIndex(bullet => bullet.classList.contains('swiper-pagination-bullet-active'));

                if (activeOriginalBulletIndex !== -1) {
                    customThumbnails.forEach((customThumb, customIndex) => {
                        const isActive = customIndex === activeOriginalBulletIndex;
                        const wasActive = customThumb.classList.contains('active');

                        if (isActive !== wasActive) {
                           customThumb.classList.toggle('active', isActive);
                           customThumb.setAttribute('aria-current', isActive ? 'true' : 'false');
                        }

                        if (isActive && customThumbnailsInnerContainer.scrollWidth > customThumbnailsInnerContainer.clientWidth) {
                            customThumb.scrollIntoView({
                                behavior: 'smooth',
                                block: 'nearest',
                                inline: 'start'
                            });
                        }
                    });
                }
            }
        };

        const observer = new MutationObserver(observerCallback);
        const observerConfig = {
            attributes: true,
            attributeFilter: ['class'],
            childList: true,
            subtree: true
        };
        observer.observe(targetNode, observerConfig);

        try {
            const initialOriginalBullets = Array.from(targetNode.querySelectorAll('.swiper-pagination-bullet'));
            let initialActiveOriginalBulletIndex = initialOriginalBullets.findIndex(bullet => bullet.classList.contains('swiper-pagination-bullet-active'));
            
            if (initialActiveOriginalBulletIndex !== -1 && customThumbnailsInnerContainer && customThumbnails.length > 0) {
                customThumbnails.forEach((customThumb, customIndex) => {
                    const isActive = customIndex === initialActiveOriginalBulletIndex;
                    customThumb.classList.toggle('active', isActive);
                    customThumb.setAttribute('aria-current', isActive ? 'true' : 'false');
                    if (isActive && customThumbnailsInnerContainer.scrollWidth > customThumbnailsInnerContainer.clientWidth) {
                         customThumb.scrollIntoView({ behavior: 'auto', block: 'nearest', inline: 'start' });
                    }
                });
            }
        } catch (e) {
            // Error handling suppressed
        }
    }

    let observerAttempts = 0;
    const maxObserverAttempts = 20;
    const observerInterval = 250;

    function findPaginationAndInitObserver() {
        const paginationContainer = document.querySelector(originalSwiperPaginationContainerSelector);
        if (paginationContainer) {
            setupObserver(paginationContainer);
        } else {
            observerAttempts++;
            if (observerAttempts < maxObserverAttempts) {
                setTimeout(findPaginationAndInitObserver, observerInterval);
            }
        }
    }
    
    if (customThumbnails.length > 0) {
        findPaginationAndInitObserver();
    }
});


// ====================================================================================
// --- 3. Countdown Timers ---
// 功能：为页面上的指定元素创建并管理独立的倒计时器，支持本地存储以在刷新后保持状态。
// ====================================================================================
document.addEventListener('DOMContentLoaded', function() {
  function createCountdownInstance(elementId, durationMinutes, localStorageSuffix) {
    const countdownElement = document.getElementById(elementId);
    if (!countdownElement) {
      return;
    }

    const localStorageKey = `countdownEndTime_${localStorageSuffix}`;
    let countdownEndTime;
    let timerInterval;

    function startNewCountdownInternal() {
      countdownEndTime = new Date().getTime() + (durationMinutes * 60 * 1000);
      localStorage.setItem(localStorageKey, countdownEndTime.toString());
    }

    function updateCountdownInternal() {
      if (countdownEndTime === undefined) {
        countdownElement.innerHTML = "Initializing...";
        return;
      }
      const now = new Date().getTime();
      const timeLeft = countdownEndTime - now;

      if (timeLeft < 0) {
        countdownElement.innerHTML = "00:00:00:00";
        startNewCountdownInternal();
        return;
      }

      let totalMinutesLeft = Math.floor(timeLeft / (1000 * 60));
      let secondsLeft = Math.floor((timeLeft % (1000 * 60)) / 1000);

      const displayMinutes = String(totalMinutesLeft).padStart(2, '0');
      const displaySeconds = String(secondsLeft).padStart(2, '0');

      countdownElement.innerHTML = `00:00:${displayMinutes}:${displaySeconds}`;
    }

    function initializeCountdownInternal() {
      const storedEndTimeString = localStorage.getItem(localStorageKey);
      let storedEndTime = null;

      if (storedEndTimeString) {
        const parsedTime = parseInt(storedEndTimeString, 10);
        if (!isNaN(parsedTime)) {
          storedEndTime = parsedTime;
        } else {
          localStorage.removeItem(localStorageKey);
        }
      }

      if (storedEndTime && new Date().getTime() < storedEndTime) {
        countdownEndTime = storedEndTime;
      } else {
        startNewCountdownInternal();
      }

      updateCountdownInternal();
      if (timerInterval) clearInterval(timerInterval);
      timerInterval = setInterval(updateCountdownInternal, 1000);
    }

    initializeCountdownInternal();
  }

  createCountdownInstance('countdown', 3, 'd00_m03_main_cycle');
  createCountdownInstance('countdown-item', 60, 'd00_h01_coupon_cycle');
});


// ====================================================================================
// --- 4. 动态“加入购物车”按钮样式 ---
// 功能：根据产品配置动态修改“加入购物车”按钮的文本、样式和行为。
// ====================================================================================
document.addEventListener('DOMContentLoaded', function() {
  const productActionContainer = document.querySelector('.product-page--submit-action[data-product-id]');
  if (!productActionContainer) {
    return;
  }

  const currentProductIdString = productActionContainer.dataset.productId;
  const specialProductsConfigString = productActionContainer.dataset.specialProductsConfig;
  const soldOutText = productActionContainer.dataset.soldOutText;
  const pickOptionText = productActionContainer.dataset.pickOptionText;
  const originalAddToCartText = productActionContainer.dataset.originalAddToCartText;

  const purchaseButton = document.getElementById('purchase');
  if (!purchaseButton) {
    return;
  }

  let specialProducts = [];
  try {
    if (specialProductsConfigString) {
      specialProducts = JSON.parse(specialProductsConfigString);
    }
  } catch (e) {
    console.error('Error parsing special products config:', e);
  }

  const currentSpecialProductConfig = specialProducts.find(
    config => config && typeof config.id !== 'undefined' && config.id.toString() === currentProductIdString
  );
  const isSpecialProductJS = !!currentSpecialProductConfig;

  const mobileBreakpoint = 768;

  function applySpecialButtonChanges(isInitialCall = false) {
    const isButtonDisabled = purchaseButton.disabled;
    const currentButtonTextContentForLogic = purchaseButton.textContent.trim();

    purchaseButton.style.removeProperty('font-size');
    purchaseButton.style.removeProperty('letter-spacing');

    if (isSpecialProductJS && currentSpecialProductConfig) {
      const specialStyles = currentSpecialProductConfig.style || {};

      if (!isButtonDisabled && currentButtonTextContentForLogic !== soldOutText && currentButtonTextContentForLogic !== pickOptionText) {
        let targetHtml = "";
        if (currentSpecialProductConfig.text_type === "html_content" && currentSpecialProductConfig.html_content) {
          targetHtml = currentSpecialProductConfig.html_content;
        } else if (currentSpecialProductConfig.text_type === "price_highlight" && currentSpecialProductConfig.text && currentSpecialProductConfig.price_to_highlight) {
          const plainSpecialTextTarget = currentSpecialProductConfig.text;
          const priceStringToHighlight = currentSpecialProductConfig.price_to_highlight;
          const escapedPriceString = priceStringToHighlight.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
          targetHtml = plainSpecialTextTarget.replace(
            new RegExp(escapedPriceString, 'g'),
            `<span class="special-price-highlight">${priceStringToHighlight}</span>`
          );
        } else if (currentSpecialProductConfig.text) {
            targetHtml = currentSpecialProductConfig.text;
        }

        if (targetHtml && purchaseButton.innerHTML !== targetHtml) {
          purchaseButton.innerHTML = targetHtml;
        }

        if (specialStyles.background_color) purchaseButton.style.setProperty('background-color', specialStyles.background_color, 'important');
        if (specialStyles.color) purchaseButton.style.setProperty('color', specialStyles.color, 'important');
        if (specialStyles.border_color) purchaseButton.style.setProperty('border-color', specialStyles.border_color, 'important');
        if (specialStyles.line_height) purchaseButton.style.setProperty('line-height', specialStyles.line_height, 'important');
        if (specialStyles.padding_top) purchaseButton.style.setProperty('padding-top', specialStyles.padding_top, 'important');
        if (specialStyles.padding_bottom) purchaseButton.style.setProperty('padding-bottom', specialStyles.padding_bottom, 'important');
        if (specialStyles.text_align) purchaseButton.style.setProperty('text-align', specialStyles.text_align, 'important');

        purchaseButton.classList.remove('secondary-button');

        if (window.innerWidth <= mobileBreakpoint) {
          if (specialStyles.font_size_mobile) purchaseButton.style.setProperty('font-size', specialStyles.font_size_mobile, 'important');
          if (specialStyles.letter_spacing_mobile && currentSpecialProductConfig.text_type !== "html_content") {
             purchaseButton.style.setProperty('letter-spacing', specialStyles.letter_spacing_mobile, 'important');
          } else {
            purchaseButton.style.removeProperty('letter-spacing');
          }
        } else {
          if (specialStyles.font_size_desktop) purchaseButton.style.setProperty('font-size', specialStyles.font_size_desktop, 'important');
          purchaseButton.style.removeProperty('letter-spacing');
        }
      } else {
        purchaseButton.style.removeProperty('background-color');
        purchaseButton.style.removeProperty('color');
        purchaseButton.style.removeProperty('border-color');
        purchaseButton.style.removeProperty('line-height');
        purchaseButton.style.removeProperty('padding-top');
        purchaseButton.style.removeProperty('padding-bottom');
        purchaseButton.style.removeProperty('text-align');
      }
    } else {
      purchaseButton.style.removeProperty('background-color');
      purchaseButton.style.removeProperty('color');
      purchaseButton.style.removeProperty('border-color');
      purchaseButton.style.removeProperty('line-height');
      purchaseButton.style.removeProperty('padding-top');
      purchaseButton.style.removeProperty('padding-bottom');
      purchaseButton.style.removeProperty('text-align');
    }
  }

  try {
    applySpecialButtonChanges(true);
  } catch (e) {
    console.error("Error during initial applySpecialButtonChanges:", e);
  }

  const observer = new MutationObserver(function(mutationsList) {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList' || (mutation.type === 'attributes' && (mutation.attributeName === 'disabled' || mutation.attributeName === 'class'))) {
        setTimeout(() => applySpecialButtonChanges(false), 50);
        break;
      }
    }
  });
  observer.observe(purchaseButton, {
    childList: true, attributes: true, attributeFilter: ['disabled', 'class'], subtree: true
  });

  const variantSelectors = document.querySelectorAll(
    'form[action^="/cart/add"] select, form[action^="/cart/add"] input[type="radio"]'
  );
  function handleVariantChange() {
    setTimeout(() => applySpecialButtonChanges(false), 100);
  }
  variantSelectors.forEach(selector => {
    selector.addEventListener('change', handleVariantChange);
  });

  let resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function() {
      if (purchaseButton && document.body.contains(purchaseButton)) {
        applySpecialButtonChanges(false);
      }
    }, 150);
  });
});


// ====================================================================================
// --- 5. 自定义“立即购买”按钮 (绕过购物车) ---
// 功能：点击“立即购买”按钮时，获取当前选定的产品变体和数量，并直接跳转到结账页面，从而绕过购物车页面。
// ====================================================================================
document.addEventListener('DOMContentLoaded', function() {
  const buyNowButton = document.getElementById('custom-paypal-button');
  const productForm = document.querySelector('form[action="/cart/add"]');
  
  if (!buyNowButton || !productForm) {
    console.error('Custom Buy Now Button: Missing required elements.');
    if(buyNowButton) buyNowButton.style.display = 'none'; // 如果找不到表单，就隐藏按钮
    return;
  }

  buyNowButton.addEventListener('click', function(event) {
    event.preventDefault();

    const variantIdInput = productForm.querySelector('[name="id"]');
    const quantityInput = productForm.querySelector('[name="quantity"]');

    if (!variantIdInput || !variantIdInput.value) {
      alert('Could not find product variant. Please select an option.');
      return;
    }

    const variantId = variantIdInput.value;
    const quantity = quantityInput ? quantityInput.value : '1';
    const checkoutUrl = `/cart/${variantId}:${quantity}?checkout`;
    window.location.href = checkoutUrl;
  });
});
